import { writable } from 'svelte/store';

export const domainName = writable('');
export const selector = writable('');

export const record = writable([]);
export const lookupFound = writable(false);

export const lookupBimiFound = writable(false);
export const lookupBimiDmarcFound = writable(false);

export const modifyRecord = writable({
  firstName: '',
  lastName: '',
  email: '',
  company: '',
  domain_name: '',
  p: 'none',
  rua: '',
  agari_rua: '',
  ruf: '',
  agari_ruf: '',
  rf: 'afrf',
  adkim: '',
  aspf: '',
  pct: 100,
  sp: 'none',
  fo: 1,
  ri: 24,
});
export const recordCreated = writable({});
export const newRecordCreated = writable(false);
